import React, { useEffect, useState } from "react";
import { Col, Row } from "antd";
import { useTranslation } from "react-i18next";
import { SelectAtomic } from "../../../../Atomics/SelectAtomic";
import { PageContent } from "../../../../../../styles/global/Pages.styled";
import clsx from "clsx";
import { BuildingEletricEnergy } from "../BuildingEletricEnergy/BuildingEletricEnergy";
import { BuildingProductionEnergy } from "../BuildingProductionEnergy/BuildingProductionEnergy";
import { BuildingLoadDiagram } from "../BuildingLoadDiagram/BuildingLoadDiagram";
import { BuildingExportRawData } from "../BuildingExportRawData/BuildingExportRawData";
import { BuildingCostTable } from "../BuildingCostTable/BuildingCostTable";
import { BuildingGasConsumption } from "../BuildingGasConsumption/BuildingGasConsumption";
import { EventsTable } from "../EventsTable/EventsTable";
import { BuildingRelatedAssetsTable } from "../BuildingRelatedAssetsTable/BuildingRelatedAssetsTable";
import { CertificationTable } from "../CertificationsTable/CertificationsTable";
import { months, years } from "../../../../../../utils/dummydata";
import logger from "../../../../../../server/server";
import { useAuthContext } from "../../../../../../contexts/AuthContext";

// Componente principal que exibe o histórico de consumo energético de um edifício
export const BuildingEnergeticConsumptionHistoricNew = ({
  building,
  currentFloor,
  ...props
}) => {
  // Hook de tradução
  const { t } = useTranslation();
  const {user,tenant} = useAuthContext();
  useEffect(() => {
    logger.info("User: " + user?.Username + " entered BuildingEnergeticConsumptionHistoricNew successfully! Tenant: " + tenant);
  }, []);

  

  const [currentCPE, setCurrentCPE] = useState(null);

  // Definindo o mês e ano atuais
  const [selectedMonth, setSelectedMonth] = useState(
    months(t).find((month) => month.value === (new Date().getMonth() + 1))?.value
  );

  const [selectedYear, setSelectedYear] = useState(
    years.find((year) => year.value === (new Date().getFullYear()))?.value);

  return (
    <>
      {/* Conteúdo da página com layout e estrutura com Col e Rows */}
      <PageContent className={clsx("building_room_details", props?.className)}>
        {/* {!isFetching ? ( //check if the data is still fetching */}
        <Row gutter={[16, 16]}>
          {/* Define o layout de linhas com largura total */}
          <Col span={24} style={{ alignContent: "center" }}>
            <Row>
              <Col span={10}>
                <h3>
                  {building?.name} |{" "}
                  {t("Energetic Consumption").toLocaleUpperCase()}{" "}
                  {/* Changes the title to upperCase and translates it */}
                </h3>
              </Col>
              <Col span={10} offset={4} style={{ alignContent: "center" }}>
                <Row gutter={16}>
                  <Col span={8}>
                    <SelectAtomic
                      optionsData={months(t)}
                      handleOptionsChange={(value) => {
                        setSelectedMonth(value);
                      }}
                      defaultValue={selectedMonth}
                      fullWidth={true}
                    />
                  </Col>
                  <Col span={8}>
                    <SelectAtomic
                      optionsData={years}
                      handleOptionsChange={(value) => {
                        setSelectedYear(value);
                      }}
                      defaultValue={selectedYear}
                      fullWidth={true}
                    />
                  </Col>
                  <Col span={8}>
                    <SelectAtomic
                      optionsData={currentFloor?.cpes?.map(x => { return { label: x.name, value: x.id } })}
                      handleOptionsChange={(value, record) => {
                        setCurrentCPE(value);
                      }}
                      defaultValue={currentCPE}
                      fullWidth={true}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>

          {/* Widgets com dados de consumo energético */}
          <Col span={24}>
            <BuildingEletricEnergy />
          </Col>

          <Col span={24}>
            <BuildingProductionEnergy />
          </Col>

          {/* Diagrama de Cargas */}
          <Col span={24}>
            <BuildingLoadDiagram />
          </Col>

          {/* Exportação Aqui */}
          <Col span={24}>
            <BuildingExportRawData />
          </Col>

          <Col span={24}>
            <BuildingCostTable />
          </Col>

          <Col span={24}>
            <BuildingGasConsumption />
          </Col>

          <Col span={24}>
            <CertificationTable />
          </Col>

          <Col span={24}>
            {/* Eventos Aqui */}
            <EventsTable />
          </Col>

          <Col span={24}>
            {/* Eventos Aqui */}
            <BuildingRelatedAssetsTable />
          </Col>

        </Row>
        {/* ) : (
          <Flex justify="center">
            <Spinner stroke="green" size="42px" />
          </Flex> //while data is fetching, a simple spinner will show up in the page
        )} */}
      </PageContent>
    </>
  );
};
